import PickupScheduler from '../PickupScheduler';
import { useTranslation } from '../../context/TranslationContext';
import './FulfillmentSection.css';

export default function FulfillmentSection({
  fulfillmentMethod, setFulfillmentMethod, setSelectedAddressId, addresses = [],
  locations, holidays = [], pickupLocationId, setPickupLocationId,
  pickupTime, setPickupTime, pickupDate, setPickupDate,
}) {
  const { t, langCode } = useTranslation();

  const selectedLocation = locations.find((l) => l.id === pickupLocationId);

  return (
    <fieldset
      className="fulfillment-section"
      style={{ marginBottom: '20px', border: 0, padding: 0 }}
    >
      <legend>
        <h3 style={{ margin: 0 }}>{t('fulfillmentMethod', 'Receive order via')}</h3>
      </legend>
      <div style={{ display: 'flex', gap: '16px', marginTop: '10px' }}>
        <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <input
            type="radio"
            name="fulfillment"
            value="delivery"
            checked={fulfillmentMethod === 'delivery'}
            onChange={() => {
              setFulfillmentMethod('delivery');
              const defaultAddr = addresses.find(a => a.is_default) || addresses[0];
              setSelectedAddressId(prev => prev || (defaultAddr ? defaultAddr.id : prev));
            }}
          />
          {t('deliveryMethod', 'Home Delivery')}
        </label>
        <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <input
            type="radio"
            name="fulfillment"
            value="pickup"
            checked={fulfillmentMethod === 'pickup'}
            onChange={() => { setFulfillmentMethod('pickup'); setSelectedAddressId(null); }}
          />
          {t('pickUp', 'Pick from location')}
        </label>
      </div>

      {fulfillmentMethod === 'pickup' && (
        <div className="pickup-location-box" style={{ padding: '1rem', background: '#f7fafc', marginBottom: '1rem', borderRadius: '6px', border: '1px solid #e2e8f0' }}>
          <h4 style={{ marginTop: 0, marginBottom: '10px' }}>{t('pickupFacilityDetails', 'Pickup Facility Details')}</h4>

          <label htmlFor="fulfillment-pickup-location" className="sr-only">
            {t('selectValidPickupLocation', 'Select a valid pickup location…')}
          </label>
          <select
            id="fulfillment-pickup-location"
            required
            value={pickupLocationId}
            onChange={(e) => {
              setPickupLocationId(e.target.value);
              setPickupTime('');
              setPickupDate('');
            }}
            aria-label={t('selectValidPickupLocation', 'Select a valid pickup location…')}
            style={{ width: '100%', maxWidth: 480, padding: '0.6rem', borderRadius: '4px', border: '1px solid #cbd5e0' }}
          >
            <option value="" disabled>{t('selectValidPickupLocation', 'Select a valid pickup location…')}</option>
            {locations.map((loc) => (
              <option key={loc.id} value={loc.id}>{loc.name} - {loc.address}</option>
            ))}
          </select>

          {selectedLocation?.instructions && (
            <p className="pickup-instructions">
              <strong>{t('note', 'Note')}:</strong> {selectedLocation.instructions}
            </p>
          )}

          {pickupLocationId && (
            <div style={{ marginTop: '12px' }}>
              <PickupScheduler
                windows={selectedLocation?.times ?? []}
                holidays={holidays}
                pickupDate={pickupDate}
                setPickupDate={setPickupDate}
                pickupTime={pickupTime}
                setPickupTime={setPickupTime}
                t={t}
                langCode={langCode}
              />
            </div>
          )}
        </div>
      )}
    </fieldset>
  );
}
